import React from 'react'
import { Flag, FlagCardMetaProps } from '../data/types'
import { Button } from './ui/Button'
import { EditIcon, DeleteIcon } from '../icons'


type Props = {
    flag: Flag
    meta: FlagCardMetaProps
    onEdit?: (flag: Flag) => void
    onDelete?: (flag: Flag) => void,
    [x: string]: any;
}

export const FlagCard = (props: Props) => {
    const { flag, meta, onEdit, onDelete } = props

    return (
        <div className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg">
            <div className="flex justify-between items-start mb-2">
                <div className="flex-1">
                    <h5 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">
                        {flag.name}
                    </h5>
                    {flag.description && (
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            {flag.description}
                        </p>
                    )}
                    {flag.hidden_from_registration && (
                        <span className="inline-block mt-1 px-2 py-0.5 text-xs font-medium bg-warn-100 text-warn-800 dark:bg-warn-900 dark:text-warn-200 rounded">
                            {meta.hiddenFromRegistrationLabel}
                        </span>
                    )}
                </div>
                {(onEdit || onDelete) && (
                    <div className="flex gap-1 ms-2">
                        {onEdit && (
                            <Button onClick={() => onEdit(flag)} variant="icon" size="sm" title="Edit flag">
                                <EditIcon className="w-4 h-4" />
                            </Button>
                        )}
                        {onDelete && (
                            <Button onClick={() => onDelete(flag)} variant="icon" color="danger" size="sm" title="Delete flag">
                                <DeleteIcon className="w-4 h-4" />
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )

}
